// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { Typography } from "@insite/mobius/index";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import React, { FC } from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasCategoryContext;

interface CategoryDescriptionStyles {
    description?: TypographyPresentationProps;
}

const categoryDescriptionStyles: CategoryDescriptionStyles = {
    description: {
        forwardAs: "p",
        size: 16,
        lineHeight: "22px",
        weight: 400,
        color: "text.main",
        css: css`
            display: flex;
            margin-top: 12px;
        `,
    },
};

const styles = categoryDescriptionStyles;
const CategoryDescription: FC<Props> = ({ category }) => {
    if (!category) {
        return null;
    }
    return (
        <Typography {...styles.description} data-test-selector="category-description-widget">
            {category.shortDescription}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: withCategory(CategoryDescription),
    definition: {
        group: "Category Details",
        icon: "list-ul",
        displayName: "Category Description",
        allowedContexts: ["CategoryDetailsPage"],
    },
};

export default widgetModule;
